import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { ShiftRequestRedesign } from '~/constants/ff.posthog';
import { useFeatureFlagVariant } from './useFeatureFlagVariant';
import { usePosthog } from './usePosthog';

const SHIFT_REQUEST_PATHS = ['/dashboard/shift-request/', '/dashboard/multi-day/'];

const isShiftRequestPath = (pathname: string): boolean =>
  SHIFT_REQUEST_PATHS.some((path) => pathname.startsWith(path));

export const useShiftRequestSessionRecording = () => {
  const location = useLocation();
  const posthog = usePosthog();
  const isRecordingRef = useRef(false);

  const isControlVariant = useFeatureFlagVariant(ShiftRequestRedesign, 'control');
  const isTestVariant = useFeatureFlagVariant(ShiftRequestRedesign, 'test');
  const isInExperiment = isControlVariant || isTestVariant;

  useEffect(() => {
    const shouldRecord = isInExperiment && isShiftRequestPath(location.pathname);

    if (shouldRecord && !isRecordingRef.current) {
      posthog.startSessionRecording();
      isRecordingRef.current = true;
    } else if (!shouldRecord && isRecordingRef.current) {
      posthog.stopSessionRecording();
      isRecordingRef.current = false;
    }
  }, [location.pathname, posthog, isInExperiment]);

  // Stop recording on unmount only (separate effect to avoid stop/start flicker on route changes)
  useEffect(() => {
    return () => {
      posthog.stopSessionRecording();
    };
  }, [posthog]);
};
